import SwiperComponent from "@components/SwiperComponent";
import {process} from './data.js'
export const DevelopmentProcess = () => {
  return (
    <section className="container">
      <SwiperComponent
        process={process}
        heading="Our Native App Development Process"
      />
    </section>
  );
};
